import { render, staticRenderFns } from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=template&id=231160b6"
import script from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSettingsQuestionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports